import React, { useEffect, useRef } from 'react';
import { sortBy } from 'lodash-es';
import { useFriendsContext } from '../../state/FriendsContext';
import { t } from '../../utils/friendsUtils';
import { INVITE_FRIENDS, ONBOARDING } from '../../utils/friendsConstants';
import InviteFriendsHeader from './InviteFriendsHeader';
import FriendList from '../shared/FriendList';
import FriendListItem from '../shared/FriendListItem';

/* display list of friends with CTA to follow them */
const FacebookFriendList = () => {
  const { state, track } = useFriendsContext();
  const { friends, source } = state;
  const sortedFriends = sortBy(Object.values(friends), 'sortedIndex');
  const friendCount = sortedFriends.length;
  const onboardingFriendCountMessage = (() => {
    switch (friendCount) {
      case 0:
        return t('friend_list.no_fb_matches');
      case 1:
        return t('friend_list.one_friend_to_follow');
      default:
        return t('friend_list.more_friends_to_follow', {
          friend_count: friendCount
        });
    }
  })();

  // friends will change as friends get followed, so we
  // want to track the initial screen_enter
  const initialScreenEnter = useRef(true);
  useEffect(() => {
    if (initialScreenEnter.current) {
      const analytics = {
        element: 'facebook_friends_list',
        action: 'screen_enter',
        properties: {
          friends_count: friendCount
        }
      };
      if (source === INVITE_FRIENDS) {
        analytics.properties.current_tab = 'facebook';
      }
      track(analytics);
      initialScreenEnter.current = false;
    }
  }, [friendCount, source, track]);

  return (
    <>
      {source === INVITE_FRIENDS && (
        <InviteFriendsHeader sortedFriends={sortedFriends} />
      )}
      {source === ONBOARDING && <p>{onboardingFriendCountMessage}</p>}
      {source === INVITE_FRIENDS && friendCount === 0 && (
        <p>{t('friend_list.no_fb_friends_on_strava')}</p>
      )}
      {friendCount > 0 && (
        <FriendList>
          {sortedFriends.map((friend) => (
            <FriendListItem id={friend.id} key={friend.id} />
          ))}
        </FriendList>
      )}
    </>
  );
};

export default FacebookFriendList;
